<template>
    <b-card class="e-square-card interactive" :class="['theme-' + theme, { 'inverted': theme === `dark` }]" no-body @click="onClicked">
        <div class="thumbnail" v-if="imgSrc">
            <b-img fluid-grow :src="imgSrc"/>
        </div>
        <b-card-body>
            <slot name="content">
                <div class="name">
                    <slot name="name">{{ name |tr}}</slot>
                </div>

                <slot></slot>

                <div class="price" v-if="price || $slots.price">
                    <slot name="price">
                        {{priceText|tr}} {{price}}
                    </slot>
                </div>

                <div v-if="showButton || $slots.action" class="action mt-2">
                    <slot name="action"></slot>
                    <b-btn variant="primary" block :href="href" target="_blank">
                        <slot name="button">
                            <template v-if="showPriceInButton && price">
                                {{priceText|tr}} {{price}}
                            </template>
                            <template v-else>
                                {{buttonText|tr}}
                            </template>
                        </slot>
                    </b-btn>
                </div>
            </slot>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: `e-square-card`,
    props: {
        loading: {type: Boolean},
        theme: {type: String, default: `light`},
        item: {type: Object},
        imgSrc: {type: String},
        href: {type: String},
        name: {type: String},
        buttonText: {type: String, default: `Buy Now|Acheter Maintenant`},
        showButton: {type: Boolean},
        price: {type: String},
        priceText: {type: String, default: `From|À partir de`},
        showPriceInButton: {type: Boolean},
        showPrice: {type: Boolean, default: true}
    },
    methods: {
        onClicked(event) {
            this.$emit(`click`, event);
            window.open(this.href, `_blank`);
        }
    }
}
</script>

<style lang="scss" scoped>
.e-square-card {
    display: inline-flex;
    flex-direction: column;

    width: 320px;
    max-width: 100%;
    margin: 10px;
    cursor: pointer;
    transition: 250ms;
    top: 0;

    &:hover {
        box-shadow: 0 10px 20px rgba(black, 0.25);
        top: -5px;
    }

    .thumbnail {
        border-radius: inherit;

        img {
            border-top-left-radius: inherit;
            border-top-right-radius: inherit;
        }
    }

    .name {
        font-weight: 500;
        font-size: 12pt;
    }

    .price {
        text-align: right;
        font-style: italic;
        opacity: .7;
    }

    @media(max-width: 600px) {
        margin: 10px auto;
    }

    &.theme-dark {
        background: #111;
        color: #eee;
    }
}
</style>
